<template>
  <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-8">
    <div class="cf-flex cf-flex--row cf-flex--gap-8">
      <div
        v-if="firstOpenCloseTimeframe"
        class="cf-flex cf-flex--row cf-flex--align-end cf-flex--gap-10"
      >
        <span class="cf-icon far fa-clock" />

        <p class="cf-subtitle cf-subtitle--2 cf-subtitle--black">

          {{ $timeOfDay(firstOpenCloseTimeframe.open, true) }} – {{ $timeOfDay(firstOpenCloseTimeframe.close, true) }}
        </p>
      </div>
    </div>

    <button
      v-if="isMultiOpenCloseTimeframes"
      class="cf-link cf-link--brand-secondary cf-link--heavy"
      type="button"
      @click="openStoreDetailsHandler"
    >
      View additional hours...
    </button>
  </div>
</template>


<script>
  export default {
    name: 'CfStoreOperatingHours',

    props: {
      location: {
        type: Object,
        required: true
      }
    },

    computed: {
      isMultiOpenCloseTimeframes() {
        return this.location.currentDayOperatingSchedule.openCloseItems.length > 1;
      },

      firstOpenCloseTimeframe() {
        return this.location.currentDayOperatingSchedule.openCloseItems[0];
      }
    },

    methods: {
      openStoreDetailsHandler() {
        this.$openModal('locationDetails', { location: this.location });
      }
    }
  };
</script>
